<template>
  <b-modal
    centered
    v-model="value"
    @hide="$emit('closed')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #modal-header="{ close }" v-if="$slots.header">
      <slot name="header"></slot>
      <b-icon
        icon="x"
        class="ml-2 text-dark-blue cursor-pointer align-self-center"
        @click="close()"
      ></b-icon>
    </template>

    <template #default>
      <slot></slot>
    </template>

    <template #modal-footer v-if="$slots.footer">
      <slot name="footer"></slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDialog',
  props: {
    value: { type: Boolean },
    titie: { type: String, default: '' },
  },
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';
.modal-dialog {
  color: $text-color;

  header.modal-header {
    .b-icon.bi-x {
      font-size: 30px;
    }
  }

  .modal-body {
    padding: 0;
  }

  footer.modal-footer {
    padding: 0;
    border: none;
  }
}
</style>
